<script>
    import R, {LOADER} from "../../lib/js/requests";
    import app from "../../lib/stores/app.js";
    import Modal from "./Modal.svelte";

    export let tour_id;
    export let onClose = () => {
    };

    let tour = null;

    const load = () => {
        const onSuccess = result => {
            tour = result;
        }

        const onFailure = err => {
        };

        R.handle(R.app.tour_details, tour_id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

{#if tour != null}
    <Modal xl title="Private tour info" on:close={onClose}>
        <div slot="body" class="p-4">
            <div class="row">
                {#if tour.images.length > 0}
                    <div class="col-md-2">
                        <div class="d-flex flex-column gap-4">
                            {#each tour.images as image}
                                <img src="{$app.image_url}/tours/{image.filename}" class="img-fluid tour-image" alt="tour image">
                            {/each}
                        </div>
                    </div>
                    <div class="col-md-10">
                        <div class="h5">{tour.name}</div>
                        <div class="tour-content">
                            {@html tour.content}
                        </div>
                    </div>
                {:else}
                    <div class="h5">{tour.name}</div>
                    <div class="tour-content">
                        {@html tour.content}
                    </div>
                {/if}
            </div>
        </div>
        <div slot="footer" class="text-end p-4">
            <button class="btn btn-link" on:click={onClose}>Close</button>
        </div>
    </Modal>
{/if}

<style>
    :global(.tour-content p) {
        margin-bottom: 0;
    }
    .tour-image {
        border-radius: 5px;
    }
</style>